<template>
<v-container class="fill-height data-container" fluid>

    <v-stepper class="stepper" v-model="currentStep">
            
        <v-stepper-header style="height: 50px;">
            <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable color="#c42111" :rules="[() => validation.userThresholdStepForm($refs.thresholdInfoForm)]">Threshold Info</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable color="#c42111" :rules="[() => reportParamsFormValid]">Report Parameters</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="3" :complete="currentStep > 3" editable color="#c42111" :rules="[() => validation.userThresholdStepForm($refs.thresholdCriteriaForm)]">Threshold Criteria</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="4" :complete="currentStep > 4" editable color="#c42111">Filters</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="5" :complete="currentStep > 5" editable color="#c42111">Schedule</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="stepper-content-container">

            <v-stepper-content :step="1" class="stepper-content">
                <v-form ref="thresholdInfoForm" class="fill-height" :lazy-validation="true" v-model="thresholdInfoFormValid">
                    <v-container class="fill-height" fluid>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field label="Threshold Name" color="#c42111" v-model="$props.userThreshold.thres_name" :rules="[validation.required($props.userThreshold.thres_name, 'Threshold Name')]" />
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-autocomplete label="Report" color="#c42111" v-model="$props.userThreshold.thres_obj" :items="$props.resources.reports" item-text="name" return-object @change="reportChange" :rules="[validation.required($props.userThreshold.thres_obj, 'Threshold Report')]" />
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-autocomplete label="Report View" color="#c42111" v-model="$props.userThreshold.webapp_view_id" :items="selectedReportViews" item-text="view_name" item-value="view_id" :disabled="!selectedReport" :hint="$props.userThreshold.webapp_view_id ? 'View column sorting cannot be applied to excel files' : ''" persistent-hint />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-stepper-content>

            <v-stepper-content :step="2" class="stepper-content">
                <v-form ref="reportParamsForm" class="fill-height" :lazy-validation="true" v-model="reportParamsFormValid">
                    <v-container class="fill-height" fluid v-if="selectedReport">
                        <report-params :reportTitle="selectedReport.reportTitle" :reportDetails="selectedReport.selectedReportDetails" :collectMode="true" :initalParamValues="$props.userThreshold.thres_params.slice()" :actionButtonText="''" :actionTrigger="reportParamsActionTrigger" @action="setReportParams" :validationStatus="reportParamsFormValid" @notes="showReportNotes = true" v-if="showReportParams"></report-params>
                    </v-container>
                    <v-container class="fill-height" fluid v-else>
                        <span>Please Select a Report First</span>
                    </v-container>
                </v-form>
            </v-stepper-content>

            <v-stepper-content :step="3" class="stepper-content">
                <v-form ref="thresholdCriteriaForm" class="fill-height" :lazy-validation="true" v-model="thresholdCriteriaFormValid">
                    <v-container class="fill-height" fluid v-if="$props.userThreshold.thres_obj">
                        <v-row>
                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Format" color="#c42111" v-model="$props.userThreshold.thres_method" :items="formatsList" @change="formatChange" :disabled="!$props.userThreshold.thres_obj" />
                            </v-col>

                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Metric" color="#c42111" v-model="$props.userThreshold.thres_column" :items="metricsList" :disabled="!$props.userThreshold.thres_obj" />
                            </v-col>

                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Threshold" v-if="!$props.userThreshold.thres_method == 0" color="#c42111" v-model="$props.userThreshold.thres_method_column" :items="thresholdsList" :disabled="!$props.userThreshold.thres_obj" />
                                <v-text-field label="Threshold" v-if="$props.userThreshold.thres_method == 0" color="#c42111" disabled :value="metricsList.length ? metricsList[$props.userThreshold.thres_column].text : ''" :disabled="!$props.userThreshold.thres_obj" />
                            </v-col>
                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Condition" color="#c42111" v-model="$props.userThreshold.thres_test" :items="conditionsList" :disabled="!$props.userThreshold.thres_obj" @change="(val) => {if(val == 6) {$props.userThreshold.thres_value = 0;}}" />
                            </v-col>
                            <v-col cols="12" md="6" xl="4">
                                <v-text-field label="Value" type="number" color="#c42111" v-model="$props.userThreshold.thres_value" :rules="[validation.required($props.userThreshold.thres_value, 'Value')]" :disabled="!$props.userThreshold.thres_obj || $props.userThreshold.thres_test == 6" />
                            </v-col>

                            <v-col cols="12">
                                <span style="display: block; margin-bottom: 1em;">User Threshold Criteria</span>
                                <v-list style="margin-bottom: 1em;" :disabled="!$props.userThreshold.thres_obj">
                                    <template v-for="(criteria, index) in $props.userThreshold.thres_criteria">
                                        <v-list-item :key="index">

                                        <template v-if="editCriteria != index">
                                            <v-list-item-action style="display: inline-block;">
                                            <v-btn style="margin-right: 1em;" fab dark x-small color="#c42111" @click="editCriteria = index" ><v-icon dark>mdi-pencil</v-icon></v-btn>
                                            <v-btn fab dark x-small color="#c42111" @click="deleteCriteria(index)"><v-icon dark>mdi-delete</v-icon></v-btn>
                                            </v-list-item-action>
                                            <span v-text="criteriaText(criteria)" />
                                        </template>

                                        <template v-if="editCriteria == index">
                                            <v-list-item-action style="display: inline-block;">
                                                <v-btn fab dark x-small color="#c42111" @click="editCriteria = -1" ><v-icon dark>mdi-check</v-icon></v-btn>
                                            </v-list-item-action>
                                            <v-col>
                                                <v-select label="Metric" color="#c42111" :items="metricsList" :value="getCriteriaValue(criteria).metric" @change="setCriteriaValue($event, 0, index) "/>
                                            </v-col>
                                            <v-col>
                                                <v-select label="Condition" color="#c42111" :items="conditionsList.slice(0,-1)" :value="getCriteriaValue(criteria).condition" @change="setCriteriaValue($event, 1, index)" />
                                            </v-col>
                                            <v-col>
                                                <v-text-field label="Value" type="number" color="#c42111" :value="getCriteriaValue(criteria).value" @change="setCriteriaValue($event, 2, index)" />
                                            </v-col>
                                        </template>

                                        </v-list-item>
                                        <v-divider :key="`divider-${index}`"></v-divider>
                                    </template>
                                    <v-btn class="ml-6 mt-3 mb-1" color="#c42111" @click="addCriteria" :disabled="!$props.userThreshold.thres_obj">Add Criteria</v-btn>
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Sort Metric" color="#c42111" v-model="$props.userThreshold.thres_sort_col" :items="sortMetricsList" :disabled="!$props.userThreshold.thres_obj" />
                            </v-col>

                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Sort Order" color="#c42111" v-model="$props.userThreshold.thres_sort_order" :items="[{value: 0, text: 'Ascending'},{value: 1, text: 'Descending'}]" :disabled="!$props.userThreshold.thres_obj" />
                            </v-col>

                            <v-col cols="12" md="6" xl="4">
                                <v-select label="Limit Result" color="#c42111" v-model="$props.userThreshold.thres_row_limit" :items="rowLimitsList" :disabled="!$props.userThreshold.thres_obj" />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-container class="fill-height" fluid v-else>
                        <span>Please Select a Report First</span>
                    </v-container>
                </v-form>
            </v-stepper-content>

            <v-stepper-content :step="4" class="stepper-content">
                <v-container class="fill-height" fluid v-if="$props.userThreshold.thres_obj">
                    <filters :filtering="filtering" :userThreshold="userThreshold" :reset="resetFilters" v-if="showFiltering"></filters>
                </v-container>
                <v-container class="fill-height" fluid v-else>
                    <span>Please Select a Report First</span>
                </v-container>
            </v-stepper-content>

            <v-stepper-content :step="5" class="stepper-content">
                <v-container class="fill-height" fluid v-if="$props.userThreshold.thres_obj">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-checkbox style="display: inline-block;" class="mr-4" v-model="$props.userThreshold.include_today" color="#c42111" label="Include Today" :disabled="$props.userThreshold.today_only" />
                            <v-checkbox style="display: inline-block;" class="ml-4" v-model="$props.userThreshold.today_only" color="#c42111" label="Today Only" @change="() => {if($props.userThreshold.today_only){$props.userThreshold.include_today = true}}" />
                        </v-col>
                        <v-col cols="12">
                            <days-of-week :threshold="userThreshold"></days-of-week>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container class="fill-height" fluid v-else>
                    <span>Please Select a Report First</span>
                </v-container>
            </v-stepper-content>

        </v-stepper-items>

    </v-stepper>

    <v-btn class="mt-3 mr-3" color="#c42111" @click="okClick">OK</v-btn>
    <v-btn class="mt-3 mr-9" color="#c42111" @click="$emit('cancel')">Cancel</v-btn>
    <v-btn class="mt-3" color="#c42111" @click="$store.commit('openWikiHelp', 'OpsAlert/UserThresholds')">Help</v-btn>

    <v-dialog v-model="showHelp" max-width="80%" persistent>
        <v-container style="background: #424242;">
            <span v-html="helpHtml" />
            <v-btn @click="showHelp = false" color="#c42111">Ok</v-btn>
        </v-container>
    </v-dialog>

    <v-dialog v-model="showReportNotes" max-width="80%" width="1600px" persistent v-if="showReportNotes" @keydown="(k) => {k.key == 'Escape' ? showReportNotes = false : null}">
        <report-notes :notes="selectedReport.selectedReportDetails.notes" @close="showReportNotes = false" v-if="showReportNotes"></report-notes>
    </v-dialog>

</v-container>
</template>

<script>
import DaysOfWeek from '@/components/UserThresholds/DaysOfWeek';
import Filters from '@/components/UserThresholds/Filters';
import ReportParams from '@/components/Reports/ReportParams';
import ReportNotes from '@/components/Reports/ReportNotes';
export default {
    name: 'UserThresholdEdit',
    props: ['resources', 'userThreshold'],
    components: {
        DaysOfWeek,
        ReportParams,
        Filters,
        ReportNotes
    },

    data: () => ({
        thresholdInfoFormValid: true,
        reportParamsFormValid: true,
        thresholdCriteriaFormValid: true,
        currentStep: 1,
        editCriteria: -1,
        selectedReport: null,
        showHelp: false,
        helpHtml: "",
        filtering: [],
        showFiltering: false,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            userThresholdStepForm: (form) => ((form === undefined || form.validate()) || false),
        },
        reportParamsActionTrigger: 0,
        selectedReportViews: [],
        resetFilters: 0,
        showReportParams: false,
        firstTimeReportChanged: true,
        showReportNotes: false
    }),

    computed: {
        formatsList() {
            return this.$props.resources.formats.map((item, index) => ({
                value: index,
                text: item
            }));
        },

        metricsList() {
            return this.$props.userThreshold.thres_obj ? this.$props.userThreshold.thres_obj.columns.map((item, index) => ({
                value: index,
                text: item
            })) : [];
        },

        thresholdsList() {
            return this.$props.resources.methods.map((item, index) => ({
                value: index,
                text: item
            }));
        },

        conditionsList() {
            return this.$props.resources.conditions.map((item, index) => ({
                value: index,
                text: item
            }));
        },

        sortMetricsList() {
            if(!this.metricsList.length) {
                return [];
            }
            if(this.$props.userThreshold.thres_method == 0) {
                let arr = this.metricsList.slice();
                arr.unshift({value: -1, text: '[none]'});
                return arr
            }
            else {
                let arr = this.thresholdsList.slice();
                arr.unshift({value: -1, text: '[none]'});
                return arr
            }
        },

        rowLimitsList() {
            return this.$props.resources.limits.map((item, index) => ({
                value: index,
                text: item
            }));
        }
    },

    methods: {
        getReportInfo: function() {
            TELSA.loading(true);

            let route = (TELSA.apiHost + "report/info");
            return this.$http.post(route, {args: {report: this.$props.userThreshold.thres_obj.name}}).then(response => {
                let result = response.body;
                this.selectedReport = {
                    reportTitle: this.$props.userThreshold.thres_obj.name,
                    selectedReportDetails: result.data
                };
                this.showReportParams = true;
                let viewRoute = `${TELSA.apiHost}views/list/report|${encodeURIComponent(encodeURIComponent(this.$props.userThreshold.thres_obj.name))}`;
                return this.$http.get(viewRoute).then(viewResponse => {
                    let viewResults = viewResponse.body;
                    this.selectedReportViews = viewResults;
                    this.selectedReportViews.push({view_name: '[NONE]', view_id: null});
                });
            });
        },

        getFiltering: function() {
            let route = (TELSA.apiHost + "report/filtering");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.filtering = result.filtering;
                this.showFiltering = true;
                //TELSA.loading(false);
            });
        },

        reportChange: function(val) {
            this.$props.userThreshold.thres_criteria = [];
            this.$props.userThreshold.user_obj_id = val.id; // The selected report
            this.$props.userThreshold.thres_human_params[0] = "";
            this.$props.userThreshold.thres_params = [];
            this.$props.userThreshold.webapp_view_id = null;

            this.$props.userThreshold.thres_method = 0;
            this.$props.userThreshold.thres_column = 0;
            this.$props.userThreshold.thres_method_column = 0;
            this.$props.userThreshold.thres_test = 0;
            this.$props.userThreshold.thres_value = "";
            this.$props.userThreshold.thres_sort_col = -1;
            this.$props.userThreshold.thres_sort_order = 0;
            this.$props.userThreshold.thres_row_limit = 0;

            this.$props.userThreshold.thres_filter = "|||";
            this.resetFilters++;
            this.$props.userThreshold.thres_intersect = false;

            this.$props.userThreshold.thres_days_sun = true;
            this.$props.userThreshold.thres_days_mon = true;
            this.$props.userThreshold.thres_days_tue = true;
            this.$props.userThreshold.thres_days_wed = true;
            this.$props.userThreshold.thres_days_thu = true;
            this.$props.userThreshold.thres_days_fri = true;
            this.$props.userThreshold.thres_days_sat = true;
            this.$props.userThreshold.prev_month = false;
            
            // If this isnt the initial setting then alert user that all settings have reset.
            if(this.firstTimeReportChanged) {
                this.firstTimeReportChanged = false;
            }
            else {
                this.$store.commit('showConfirmModal', {
                    title: 'Report Changed',
                    message: 'All User Threshold settings have reset.',
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: () => {}
                });
            }

            this.showReportParams = false;
            this.getReportInfo().then(response => {
                TELSA.loading(false);
            });
        },

        formatChange: function(val) {
            if(val === 0) {
                this.$props.userThreshold.thres_method_column = 0;
            }
            this.$props.userThreshold.thres_sort_col = -1;
        },

        criteriaText: function(criteria) {
            let criteriaAnswer = "";
            const criteriaArray = criteria.split(' ');
            criteriaAnswer += `${this.$props.userThreshold.thres_obj.columns[criteriaArray[0]]} `;
            criteriaAnswer += `${this.$props.resources.conditions[criteriaArray[1]]} `;
            criteriaAnswer += `${criteriaArray[2]}`;
            return criteriaAnswer;
        },

        deleteCriteria: function(criteriaIndex) {
            this.$props.userThreshold.thres_criteria.splice(criteriaIndex, 1);
        },

        addCriteria: function() {
            this.$props.userThreshold.thres_criteria.push('0 0 0');
        },

        getCriteriaValue: function(criteria) {
            const criteriaArray = criteria.split(' ');
            return {
                metric: this.metricsList[criteriaArray[0]],
                condition: this.conditionsList[criteriaArray[1]],
                value: criteriaArray[2]
            }
        },

        setCriteriaValue: function(e, type, criteriaIndex) {
            const criteriaArray = this.$props.userThreshold.thres_criteria[criteriaIndex].split(' ');
            criteriaArray[type] = e;
            let newValue = criteriaArray.join(' ');
            this.$props.userThreshold.thres_criteria[criteriaIndex] = newValue;
        },

        setReportParams: function(paramArr, humanTextArr, valid) {
            this.reportParamsFormValid = true;
            this.$props.userThreshold.thres_params = paramArr;
            this.$props.userThreshold.thres_human_params[0] = humanTextArr.join('; ');
        },

        okClick: function() {
            this.reportParamsFormValid = false;
            this.reportParamsActionTrigger++;
            this.$nextTick(function() {
                if(this.$refs.thresholdInfoForm.validate() && this.$refs.reportParamsForm.validate() && this.reportParamsFormValid && this.$refs.thresholdCriteriaForm.validate()) {
                    this.$emit('ok');
                }
            });
        },

    },

    created() {
        this.firstTimeReportChanged = this.$props.userThreshold.thres_id === 0;
    },

    mounted() {
        let promises = [];
        promises.push(this.getFiltering());
        if(this.$props.userThreshold.thres_obj) {
            promises.push(this.getReportInfo());
        }
        Promise.all(promises).then(res => {
            TELSA.loading(false);
        });
    }


};
</script>

<style scoped>

    .stepper {
        background: #424242 !important; 
        height: calc(100vh - 126px);
        width: 100%;
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto; 
        height: calc(100% - 55px);
    }
    .stepper-content {
        /* padding: 16px 4px 4px 4px; */
    }

    .data-container {
        padding: 0;
    }

    .week-day {
        display: inline-block;
        margin-right: 3em;
    }

    .week-day-label {
        display: block;
        font-weight: bold;
    }

    .action-number {
        display: block;
        font-weight: bold;
        margin-top: calc(50%);
        font-size: 24px;
    }

</style>
